import React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import FormLabel from 'src/components/UI/input/CustomFormLabel';

export default function AddressAutocompleteInput({
  label = 'Find address',
  placeholder = 'Start typing an address…',
  inputValue,
  suggestions,
  loading,
  disabled,
  statusMessage,
  onInputChange,
  onSelect
}) {
  return (
    <Grid container spacing={1}>
      <Grid size={12}>
        <FormLabel component="label" className="form-label">
          {label}
        </FormLabel>
      </Grid>
      <Grid size={12}>
        <Autocomplete
          freeSolo
          autoComplete
          includeInputInList
          filterOptions={(options) => options}
          options={suggestions}
          getOptionLabel={(option) =>
            typeof option === 'string' ? option : option?.label || ''
          }
          isOptionEqualToValue={(option, value) => option?.id === value?.id}
          inputValue={inputValue}
          value={null}
          onInputChange={(event, next, reason) => {
            if (reason === 'input' || reason === 'clear') onInputChange(next);
          }}
          onChange={(event, option) => {
            if (option && typeof option !== 'string') onSelect(option);
          }}
          loading={loading}
          disabled={disabled}
          renderOption={(props, option) => {
            const { key, ...rest } = props;
            return (
              <Box
                component="li"
                key={key}
                {...rest}
                sx={{ display: 'flex', alignItems: 'baseline', gap: 0.75 }}
              >
                <Typography
                  component="span"
                  variant="body2"
                  sx={{ whiteSpace: 'nowrap' }}
                >
                  {option.primary}
                </Typography>
                {option.secondary && (
                  <Typography
                    component="span"
                    variant="caption"
                    color="text.secondary"
                    sx={{
                      minWidth: 0,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap'
                    }}
                  >
                    {option.secondary}
                  </Typography>
                )}
              </Box>
            );
          }}
          renderInput={(params) => {
            const inputSlot =
              params.slotProps?.input || params.InputProps || {};
            return (
              <TextField
                {...params}
                variant="outlined"
                fullWidth
                placeholder={placeholder}
                error={Boolean(statusMessage)}
                helperText={statusMessage || ''}
                slotProps={{
                  ...params.slotProps,
                  input: {
                    ...inputSlot,
                    endAdornment: loading ? (
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          mr: '9px'
                        }}
                      >
                        <CircularProgress color="inherit" size={16} />
                      </Box>
                    ) : (
                      inputSlot.endAdornment
                    )
                  }
                }}
              />
            );
          }}
        />
      </Grid>
    </Grid>
  );
}
